import { Button } from '@shared/components/ui/button';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface CreateTopupButtonProps {
  onClick: () => void;
}

export const CreateTopupButton = ({ onClick }: CreateTopupButtonProps) => {
  const { t } = useTranslation('topupsModule');

  return (
    <Button variant="primary" size="default" onClick={onClick} data-testid="create-topup-button">
      <FontAwesomeIcon icon={faPlus} className="w-4 h-4 mr-2" />
      {t('buttons.create')}
    </Button>
  );
};
